const sourcemapsupportregister = __non_webpack_require__('source-map-support/register'); module.exports = sourcemapsupportregister;